import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import withDependencies from '@factorin/container.macro';


export const ReduxProvider = withDependencies((store, history) => ({ Next }) => (
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Next />
        </ConnectedRouter>
    </Provider>
));
